function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t); "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) { return Object.getOwnPropertyDescriptor(t, e).enumerable; })), o.forEach(function (r) { _defineProperty(e, r, t[r]); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { createContext, useReducer, useMemo, useEffect } from 'react';
import TabList from '../TabList';
import TabListScrollable from '../TabListScrollable';
export var TabContext = createContext({});
var initialState = {
  selected: null,
  tabs: []
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case 'add:tab':
      if (state.tabs.length) {
        return _objectSpread({}, state, {
          tabs: state.tabs.concat(action.payload)
        });
      } else {
        return _objectSpread({}, state, {
          tabs: state.tabs.concat(action.payload),
          selected: action.payload.id
        });
      }
    case 'select-next:tab':
    case 'select-prev:tab':
      var currentIndex = state.tabs.findIndex(function (tab) {
        return tab.id === action.payload;
      });
      var selected = action.type === 'select-next:tab' ? Math.min(currentIndex + 1, state.tabs.length - 1) : Math.max(currentIndex - 1, 0);
      return _objectSpread({}, state, {
        selected: state.tabs[selected].id
      });
    case 'select:tab':
      return _objectSpread({}, state, {
        selected: action.payload
      });
  }
}
export default function Tabs(_ref) {
  var onChange = _ref.onChange,
    _ref$compact = _ref.compact,
    compact = _ref$compact === void 0 ? false : _ref$compact,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'start' : _ref$align,
    _ref$scrollable = _ref.scrollable,
    scrollable = _ref$scrollable === void 0 ? false : _ref$scrollable,
    children = _ref.children;
  var _useReducer = useReducer(reducer, initialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var context = useMemo(function () {
    return {
      selected: state.selected,
      dispatch: dispatch
    };
  }, [state.selected]);
  useEffect(function () {
    if (typeof onChange === 'function' && typeof state.selected === 'string') {
      onChange(state.selected);
    }
  }, [onChange, state.selected]);
  return /*#__PURE__*/React.createElement(TabContext.Provider, {
    value: context
  }, scrollable ? /*#__PURE__*/React.createElement(TabListScrollable, {
    align: align,
    compact: compact,
    tabs: state.tabs
  }) : /*#__PURE__*/React.createElement(TabList, {
    compact: compact,
    align: align,
    tabs: state.tabs
  }), children);
}